import React from 'react';
import { Avatar } from 'antd';
import Client from 'containers/app/client';
import { useUserWithRole } from 'hooks/custom-auth';
import './style.css';

// return a random array entry
const randomArrayItem = (arr) => {
  return arr[Math.floor(Math.random() * arr.length)];
};

const worker = [
  {
    text:
      'I work full time as a care worker doing home care. When I want some extra money for holidays, my daughter’s birthday or unexpected bills, I pick up extra shifts through My-Shifts. It’s made such a difference and a nice change to work in a residential home to.',
    name: 'Julie',
    place: 'Glasgow',
    image: '/images/portraits/julie.jpg',
  },
  {
    text:
      'I found it difficult waiting for the Agency to call with work and then sometimes they’d ask if I was free and never came back to me. My-Shifts has put me in control and taken away the stress.',
    name: 'Ali',
    place: 'Coventry',
    image: '/images/portraits/ali.jpg',
  },
  {
    text:
      'I work when I want now and have picked up 2 shifts a week on average. It’s also nice to go to different places.',
    name: 'Afzal',
    place: 'Brighton',
    image: '/images/portraits/afzal.jpg',
  },
  {
    text:
      'I get great reviews from the shifts I work, it’s nice to know you’re appreciated.',
    name: 'Rana',
    place: 'London',
    image: '/images/portraits/rana.jpg',
  },
  {
    text: 'Better than bank work, more regular and reliable.',
    name: 'Brenda, Brand 5 Nurse',
    place: 'Manchester',
    image: '/images/portraits/brenda.jpg',
  },
];

const employer = [
  {
    text:
      'Its important to us that we get the right worker with the right experience and skills. MyShifts ensure this happens as I can choose from a long list of worker type options.',
    name: 'Julie',
    place: 'Glasgow - Manager',
    image: '/images/portraits/julie.jpg',
  },
  {
    text:
      'MyShifts allows me to manage the vacancy process from start to finish. It helps me keep an eye on our worker requirement s and budget control all in one simple solution.',
    name: 'David, Care Home Owner',
    place: 'Leeds',
    image: '/images/portraits/ali.jpg',
  },
  {
    text:
      'MyShifts is great for letting people know where we are and saving time spent, by workers, travelling to and from our service location. It also helps us meet our targets on ‘sustainability’ and our carbon footprint by employing local people.',
    name: 'Afzal',
    place: 'Brighton',
    image: '/images/portraits/afzal.jpg',
  },
  {
    text:
      'MyShifts is great for letting people know where we are and saving time spent, by workers, travelling to and from our service location. It also helps us meet our targets on ‘sustainability’ and our carbon footprint by employing local people.',
    name: 'Rana',
    place: 'London',
    image: '/images/portraits/rana.jpg',
  },
  {
    text:
      'MyShifts allows me to register multiple sites and authorised people who can post vacancies and review ‘matched’ workers at any time of the day/night or day of the week. This helps get the right people at the right time to meet our service needs. It really helps us to meet our staffing ratios and ultimately compliance with our registration requirements.',
    name: 'Debbie, Managing Director',
    place: 'Nottingham',
    image: '/images/portraits/brenda.jpg',
  },
];

const stories = {
  isWorker: worker,
  isEmployer: employer,
};

const UserStories = () => {
  const [user, loading, error] = useUserWithRole(Client.auth);

  if (error) throw error;
  if (loading) return null;

  const story = randomArrayItem(stories[user.claims.role]);

  return (
    <section className="user-story">
      <Avatar src={story.image} slt={story.name} size={100} />
      <div className="items">
        <h3>&ldquo;{story.text}&rdquo;</h3>
        <h4>
          <strong>{story.name}</strong> - {story.place}
        </h4>
      </div>
    </section>
  );
};

UserStories.propTypes = {};

export default UserStories;
